export const authPaymentTypes = {
  // These payment types are valid and can be set to auth parent paymentInfo.type
  // state, which will be used to determine the payment or cancellation flow in the auth parent
  valid: {
    // Standard type for one-time payments
    Standard: "Standard",
    // Type for new recurring payments or existing recurring edits
    Recurring: "Recurring",
    // This is a valid type used to cancel an existing recurring payment
    RecurringCancellation: "RecurringCancellation",
    // Valid type used for skip a payment flow if the loan is determined to be eligible
    EligibleSkip: "EligibleSkip",
  },
  // These payment types are invalid and will prevent the user
  // from continuing, usually by displaying some sort of custom message
  invalid: {
    // Type used when there is a pending payoff for this loan
    PayoffPending: "PayoffPending",
    // Type used to display modal message when the user clicks setup autopay on a credit card
    RecurringCreditCard: "RecurringCreditCard",
    // Type used when selecting autopay and recurring payments are not allowed, or if there is no next due date
    IneligibleRecurring: "IneligibleRecurring",
    // Type used when selecting autopay but the loan is past due
    OverdueRecurring: "OverdueRecurring",
    // Type used when selecting one time payment but there is a balance of 0
    ZeroBalance: "ZeroBalance",
    // Type used for when the user selects skip a payment but the loan is determined to be ineligible
    IneligibleSkip: "IneligibleSkip",
  },
  // These types are used for unique, non-payment flow functionality
  other: {
    // This type is used when the user selects generate payoff letter
    // from the popup menu and prompts a unique download modal
    PayoffLetter: "PayoffLetter",
    // This type is used when selecting loan details from the popup menu
    // And displays unique content in the modal
    LoanDetails: "LoanDetails",
  },
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/parent/data/auth-payment-types.js